/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:18/06/2022
 @Time:14:05
 **/
import Societe from "./Societe";

export default class Client
{

    /**
     * la societe auquel est attaché un client
     * @type {Societe}
     */
    #_societe;
    /**
     * @type {?string}
     */
    #_id=null;


    get societe() {
        return this.#_societe;
    }

    set societe(value) {
        this.#_societe = value;
    }

    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }

    /**
     *
     * @param {{}} clientJson
     * @param {Client}clientBase
     */
    static createObjectFromJson(clientJson,clientBase)
    {
        Begro.logInfo("remplir les propriétés de base pour objet client");
        if(clientJson.societe!=null)
        {
            clientBase.societe=Societe.creatObjetFromJson(clientJson.societe);
            clientBase.id=clientJson.id;

        }
    }

}